import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import type { ChatMessageData } from '../_utils/message';
export const useChatMessages = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [messages, setMessages] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = newMessages => {
      setMessages(prev => [...prev, ...newMessages]);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const addMessages = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = updates => {
      setMessages(prev_0 => {
        const lastMessage = prev_0[prev_0.length - 1];
        if (!lastMessage) {
          return prev_0;
        }
        return [...prev_0.slice(0, -1), {
          ...lastMessage,
          ...updates
        }];
      });
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const updateLastMessage = t2;
  let t3;
  if ($[3] !== messages) {
    t3 = {
      messages,
      setMessages,
      addMessages,
      updateLastMessage
    };
    $[3] = messages;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};